if (!customElements.get("sock-media-gallery")) {
  customElements.define(
    "sock-media-gallery",
    class SockMediaGallery extends HTMLElement {
      constructor() {
        super();
        this.galleryMain = null;
        this.selectors = {
          toggleZoom: [".js-photoswipe--zoom"]
        }
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.destroySlider();
      }

      init() {
        this.initSlider();
        this.onlyImage = this.dataset.onlyImage === "true";
        this.enableZoom = this.dataset.enableZoom === "true";
        this.bindCustomNavigation();
        if (this.enableZoom) this.initImageZoom();
      }
      
      initImageZoom() {
        let dataSource = [];
        const allMedia = this.querySelectorAll(".f-product__media");
        if (allMedia) {
          allMedia.forEach((media) => {
            if (media.dataset.mediaType === "image") {
              dataSource.push({
                id: media.dataset.mediaIndex,
                src: media.dataset.src,
                width: media.dataset.pswpWidth,
                height: media.dataset.pswpHeight,
                mediaType: media.dataset.mediaType,
              });
            }
            if (media.dataset.mediaType === "model") {
              const html = `<div class="pswp__item--${
                media.dataset.mediaType
              }">${media.querySelector("product-model").outerHTML}</div>`;
              dataSource.push({
                id: media.dataset.mediaIndex,
                html: html,
                mediaType: media.dataset.mediaType,
              });
            }

            if (
              media.dataset.mediaType === "video" ||
              media.dataset.mediaType == "external_video"
            ) {
              const html = `<div class="pswp__item--${
                media.dataset.mediaType
              }">${media.querySelector("deferred-media").outerHTML}</div>`;
              dataSource.push({
                id: media.dataset.mediaIndex,
                html: html,
                mediaType: media.dataset.mediaType,
              });
            }
          });
        }

        const options = {
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          close: false,
          counter: false,
          preloader: false,
          maxZoomLevel: 4,
        };

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox(options);

        this.lightbox.addFilter("thumbEl", (thumbEl, data, index) => {
          const el = this.querySelector(
            '[data-media-index="' + data.id + '"] img'
          );
          if (el) {
            return el;
          }
          return thumbEl;
        });

        this.lightbox.addFilter("placeholderSrc", (placeholderSrc, slide) => {
          const el = this.querySelector(
            '[data-media-index="' + slide.data.id + '"] img'
          );
          if (el) {
            return el.src;
          }
          return placeholderSrc;
        });

        this.lightbox.on("change", () => {
          const currIndex = this.lightbox.pswp.currIndex;
          if (!this.onlyImage) {
          // console.log('this.onlyImage',this.domNodes)
            // const slider =
            //   this.domNodes.mediaGallery.slider &&
            //   this.domNodes.mediaGallery.slider.instance;
            // if (slider) {
              // setTimeout(() => {
              //   slider.select(currIndex, false, true);
              // }, 300);
            // }
          }
        });

        this.lightbox.on("pointerDown", (e) => {
          const currSlide = this.lightbox.pswp.currSlide.data;
          if (
            currSlide.mediaType === "video" ||
            currSlide.mediaType === "model" ||
            currSlide.mediaType === "external_video"
          ) {
            e.preventDefault();
          }
        });

        this.lightbox.on("uiRegister", () => {
          if (!this.onlyImage) {
            this.lightbox.pswp.ui.registerElement({
              name: "next",
              ariaLabel: "Next slide",
              order: 3,
              isButton: true,
              html: '<svg class="pswp-icon-next" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.next();
              },
            });
            this.lightbox.pswp.ui.registerElement({
              name: "prev",
              ariaLabel: "Previous slide",
              order: 1,
              isButton: true,
              html: '<svg class="pswp-icon-prev" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z" class="arrow"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.prev();
              },
            });
          }

          this.lightbox.pswp.ui.registerElement({
            name: "close-zoom",
            ariaLabel: "Close zoom image",
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="f-icon-svg f-icon--medium  f-icon-close"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: (event, el) => {
              this.lightbox.pswp.close();
            },
          });
        });

        this.lightbox.init();

        addEventDelegate({
          selector: this.selectors.toggleZoom[0],
          context: this,
          handler: (e, media) => {
            const isImage = media.dataset.mediaType === "image";
            if (isImage) {
              const index = Number(media.dataset.mediaIndex) || 0;
              this.lightbox.loadAndOpen(index);
            }
          },
        });
      }


      initSlider() {
        const galleryContainer = this.querySelector(".gallery-main");
        
        const mblSlider = this.querySelector('.mbl_slider');
        if (window.innerWidth < 768) {
          this.mblSlider = new Swiper(mblSlider, {
            watchOverflow: true,
            slidesPerView: 1,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            preventInteractionOnTransition: true,
            loop: false,
            effect: 'swipe',
            scrollbar: {
              el: this.querySelector('.swiper-scrollbar'),
              draggable: true,
            }
          });
        }
        if (!galleryContainer) return;

        this.galleryMain = new Swiper(galleryContainer, {
          watchOverflow: true,
          slidesPerView: 1,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          preventInteractionOnTransition: true,
          loop: false,
          effect: 'swipe',
          scrollbar: {
            el: this.querySelector('.swiper-scrollbar'),
            draggable: true,
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
            },
          }
        });

        this.galleryMain.on('slideChange', () => {
          const countEl = this.querySelector('.custom-pagination .count');
          if (countEl) countEl.textContent = this.galleryMain.activeIndex + 1;
        });
        window.dispatchEvent(new Event('resize'));  
        if (this.enableZoom) this.initImageZoom();
      }

      destroySlider() {
        if (this.galleryMain) {
          this.galleryMain.destroy(true, true);
          this.galleryMain = null;
        }
      }

      bindCustomNavigation() {
        const nextBtn = this.querySelector('.cs-swiper-button-next');
        const prevBtn = this.querySelector('.cs-swiper-button-prev');

        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            if (!this.galleryMain) return;
            if (this.galleryMain.activeIndex + 1 === this.galleryMain.slides.length - 1) {
              this.galleryMain.slideTo(0);
            } else {
              this.galleryMain.slideNext();
            }
          });
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            if (!this.galleryMain) return;
            if (this.galleryMain.activeIndex === 0) {
              this.galleryMain.slideTo(this.galleryMain.slides.length - 1);
            } else {
              this.galleryMain.slidePrev();
            }
          });
        }
      }
    }
  );
}
